import { createContext, useContext } from 'react';

export type Step = {
  optional: boolean;
  key: string;
};

type Context = {
  // add a step to the wizard, returns a function to remove the step
  addStep: (step: Step) => () => void;

  // The steps that are in the wizard
  steps: Step[];

  // The step that the user is currently on
  activeStep: number;

  // The function to call when the user clicks the next step button
  onNextStep: () => void;

  // The function to call when the user clicks the previous step button
  onPrevStep: () => void;
};

export const MultiStepDialogContext = createContext<Context>({
  addStep: () => () => {},
  steps: [],
  activeStep: 0,
  onNextStep: () => {},
  onPrevStep: () => {},
});

export const MultiStepDialogContextProvider = MultiStepDialogContext.Provider;

export const useMultiStepDialogContext = () => {
  const context = useContext(MultiStepDialogContext);
  if (!context) {
    throw new Error('Connect context not found');
  }
  return context;
};

type StepContextType = {
  optional: boolean;
  forceReview: boolean;
  seenEverything: boolean;
  setSeenEverything: (seenEverything: boolean) => void;
};

export const StepContext = createContext<StepContextType>({
  optional: false,
  forceReview: false,
  seenEverything: false,
  setSeenEverything: () => {},
});
